// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__T6J9c","col":"styles_col__22bom"};